import { Link } from 'react-router-dom';
import { earbudsData } from '@/mocks/mosstalk';
import ConsultationForm from '@/components/ConsultationForm';

function EarbudsPage() {
  return (
    <>
      {/* 顶部 Banner */}
      <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
        <div className="absolute inset-0 bg-primary-950/85 z-0" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50 z-[1]" />
        <div className="absolute inset-0 z-[1]">
          <img src="/images/banner-bg.jpg" alt="MossTalk 翻译耳机" className="w-full h-full object-cover object-top opacity-35" />
        </div>
        <div className="relative z-10 h-full flex flex-col items-center justify-center px-4 md:px-8 text-center">
          <div className="w-full max-w-3xl mx-auto">
            <span className="inline-block px-4 py-1.5 mb-6 text-xs md:text-sm font-medium text-white/80 border border-white/25 rounded-full backdrop-blur-sm">{earbudsData.banner.tag}</span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-tight mb-4">{earbudsData.banner.title}</h1>
            <p className="text-lg md:text-2xl text-white/80 font-light">{earbudsData.banner.subtitle}</p>
          </div>
        </div>
      </section>

      {/* 产品展示 */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/5 rounded-3xl" />
              <img src="/images/mosstalk/earbuds/2-overview.jpg" alt="MossTalk 翻译耳机" className="relative z-10 w-full rounded-2xl" />
            </div>
            <div>
              <span className="inline-block px-4 py-1.5 mb-4 text-xs font-medium text-primary-600 bg-primary-50 rounded-full">{earbudsData.overview.title}</span>
              <h2 className="text-3xl md:text-5xl font-bold text-foreground-900 leading-tight mb-6">降噪 · 通话 · 翻译<br />音乐 · 运动 五合一</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">{earbudsData.overview.content}</p>
              <div className="flex flex-wrap gap-3">
                <span className="inline-flex items-center gap-2 px-4 py-2 bg-primary-50 text-primary-600 rounded-full text-xs font-medium">
                  <i className="ri-volume-up-line text-sm"></i>100dB 深度降噪
                </span>
                <span className="inline-flex items-center gap-2 px-4 py-2 bg-accent-50 text-accent-600 rounded-full text-xs font-medium">
                  <i className="ri-global-line text-sm"></i>140+ 语种翻译
                </span>
                <span className="inline-flex items-center gap-2 px-4 py-2 bg-secondary-50 text-secondary-600 rounded-full text-xs font-medium">
                  <i className="ri-battery-charge-line text-sm"></i>40h 超长续航
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 核心数据 */}
      <section className="py-10 md:py-14 px-4 md:px-8 lg:px-12 bg-background-100">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary-500 mb-1">100dB</div>
              <div className="text-xs text-foreground-500">深度主动降噪</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-accent-500 mb-1">140+</div>
              <div className="text-xs text-foreground-500">语种实时翻译</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-secondary-500 mb-1">40h</div>
              <div className="text-xs text-foreground-500">总续航</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary-500 mb-1">&lt;200ms</div>
              <div className="text-xs text-foreground-500">翻译延迟</div>
            </div>
          </div>
        </div>
      </section>

      {/* 功能亮点 */}
      <section className="bg-background-50 py-16 md:py-24 px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-medium text-primary-600 bg-primary-50 rounded-full">核心功能</span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">{earbudsData.features.title}</h2>
          </div>

          {/* 功能 1 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-20 md:mb-28">
            <div className="lg:pr-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-4">
                <i className="ri-volume-up-line text-xl"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">{earbudsData.features.items[0].name}</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{earbudsData.features.items[0].desc}</p>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">自适应 ANC</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">双麦克风 ENC</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">通话降噪</span>
              </div>
            </div>
            <div className="overflow-hidden rounded-2xl">
              <img src="/images/mosstalk/earbuds/3-anc.jpg" alt={earbudsData.features.items[0].name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
          </div>

          {/* 功能 2 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-20 md:mb-28">
            <div className="order-2 lg:order-1 overflow-hidden rounded-2xl">
              <img src="/images/mosstalk/earbuds/4-realtime.jpg" alt={earbudsData.features.items[1].name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="order-1 lg:order-2 lg:pl-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-50 text-accent-500 mb-4">
                <i className="ri-translate text-xl"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">{earbudsData.features.items[1].name}</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{earbudsData.features.items[1].desc}</p>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">140+ 语种</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">&lt;200ms 延迟</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">语音实时互译</span>
              </div>
            </div>
          </div>

          {/* 功能 3 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-20 md:mb-28">
            <div className="lg:pr-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-4">
                <i className="ri-phone-line text-xl"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">{earbudsData.features.items[2].name}</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{earbudsData.features.items[2].desc}</p>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">双麦克风阵列</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">ENC 环境降噪</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">清晰通话</span>
              </div>
            </div>
            <div className="overflow-hidden rounded-2xl">
              <img src="/images/mosstalk/earbuds/5-hd-call.jpg" alt={earbudsData.features.items[2].name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
          </div>

          {/* 功能 4 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-20 md:mb-28">
            <div className="order-2 lg:order-1 overflow-hidden rounded-2xl">
              <img src="/images/mosstalk/earbuds/6-hifi.jpg" alt={earbudsData.features.items[3].name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="order-1 lg:order-2 lg:pl-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-50 text-secondary-500 mb-4">
                <i className="ri-music-line text-xl"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">{earbudsData.features.items[3].name}</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{earbudsData.features.items[3].desc}</p>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">12mm 大动圈</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">AAC / SBC</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">Hi-Fi 音质</span>
              </div>
            </div>
          </div>

          {/* 功能 5 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-20 md:mb-28">
            <div className="lg:pr-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-50 text-accent-500 mb-4">
                <i className="ri-run-line text-xl"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">{earbudsData.features.items[4].name}</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{earbudsData.features.items[4].desc}</p>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">IPX5 防水</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">开放式佩戴</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">环境感知</span>
              </div>
            </div>
            <div className="overflow-hidden rounded-2xl">
              <img src="/images/mosstalk/earbuds/7-sport.jpg" alt={earbudsData.features.items[4].name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
          </div>

          {/* 功能 6 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div className="order-2 lg:order-1 overflow-hidden rounded-2xl">
              <img src="/images/mosstalk/earbuds/8-battery.jpg" alt={earbudsData.features.items[5].name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="order-1 lg:order-2 lg:pl-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-4">
                <i className="ri-battery-charge-line text-xl"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">{earbudsData.features.items[5].name}</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{earbudsData.features.items[5].desc}</p>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">单次 8h</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">充电仓 32h</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">Type-C 快充</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 应用场景 */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-medium text-accent-600 bg-accent-50 rounded-full">应用场景</span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">{earbudsData.scenarios.title}</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            <div className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-accent-200 transition-all duration-300">
              <div className="h-36 md:h-44 overflow-hidden">
                <img src="/images/mosstalk/earbuds/9-commute.jpg" alt="商务通勤" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500">
                    <i className="ri-train-line text-sm"></i>
                  </div>
                  <h4 className="text-sm font-bold text-foreground-900">商务通勤</h4>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">地铁/公交/驾车通勤途中，降噪听音乐+实时翻译，碎片时间高效利用</p>
              </div>
            </div>
            <div className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-accent-200 transition-all duration-300">
              <div className="h-36 md:h-44 overflow-hidden">
                <img src="/images/mosstalk/earbuds/10-cross-border-call.jpg" alt="跨境电话" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500">
                    <i className="ri-phone-line text-sm"></i>
                  </div>
                  <h4 className="text-sm font-bold text-foreground-900">跨境电话</h4>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">跨国电话会议/视频通话，实时双语字幕翻译，沟通效率翻倍</p>
              </div>
            </div>
            <div className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-accent-200 transition-all duration-300">
              <div className="h-36 md:h-44 overflow-hidden">
                <img src="/images/mosstalk/earbuds/11-outdoor.jpg" alt="运动出行" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500">
                    <i className="ri-run-line text-sm"></i>
                  </div>
                  <h4 className="text-sm font-bold text-foreground-900">运动出行</h4>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">IPX5防水，开放式佩戴安全感知环境，跑步骑行也能畅享翻译</p>
              </div>
            </div>
            <div className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-accent-200 transition-all duration-300">
              <div className="h-36 md:h-44 overflow-hidden">
                <img src="/images/mosstalk/earbuds/12-listening.jpg" alt="外语听力学习" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500">
                    <i className="ri-headphone-line text-sm"></i>
                  </div>
                  <h4 className="text-sm font-bold text-foreground-900">外语听力学习</h4>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">外语播客/新闻/影视实时字幕翻译，沉浸式语言学习最佳伴侣</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 产品亮点 */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-medium text-accent-600 bg-accent-50 rounded-full">产品亮点</span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 mb-3">{earbudsData.advantages.title}</h2>
            <p className="text-sm md:text-base text-foreground-500">{earbudsData.advantages.subtitle}</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {earbudsData.advantages.items.map((a, idx) => (
              <div key={idx} className="flex items-start gap-4 bg-white rounded-xl p-5 md:p-6 border border-background-200">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-50 text-accent-500">
                  <i className={`${a.icon} text-lg`}></i>
                </div>
                <div>
                  <h4 className="text-sm font-bold text-foreground-900 mb-1.5">{a.name}</h4>
                  <p className="text-xs text-foreground-500 leading-relaxed">{a.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 规格参数 */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">{earbudsData.specs.title}</h2>
          </div>
          <div className="bg-white rounded-2xl border border-background-200 overflow-hidden">
            <div className="divide-y divide-background-100">
              {earbudsData.specs.rows.map((row, idx) => (
                <div key={idx} className={`flex flex-col sm:flex-row py-4 px-6 md:px-8 ${idx % 2 === 0 ? 'bg-background-50/50' : ''}`}>
                  <span className="text-xs font-semibold text-foreground-400 uppercase tracking-wider w-full sm:w-40 flex-shrink-0 mb-1 sm:mb-0">{row.label}</span>
                  <span className="text-sm text-foreground-800">{row.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 相关产品推荐 */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">{earbudsData.related.title}</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl mx-auto">
            <Link to="/mosstalk/standard" className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="h-44 overflow-hidden">
                <img src="/images/recommendation/mosstalk-standard.jpg" alt="MossTalk 标准款翻译机" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <h4 className="text-sm font-bold text-foreground-900 mb-1">MossTalk 标准款翻译机</h4>
                <p className="text-xs text-foreground-500">35g超轻指环翻译机，日常出行翻译利器</p>
              </div>
            </Link>
            <Link to="/mosstalk/business" className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="h-44 overflow-hidden">
                <img src="/images/recommendation/mosstalk-business.jpg" alt="MossTalk 商务款翻译机" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <h4 className="text-sm font-bold text-foreground-900 mb-1">MossTalk 商务款翻译机</h4>
                <p className="text-xs text-foreground-500">AI会议总结+思维导图，商务专属翻译</p>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* 行动号召 */}
      <section className="py-12 md:py-16 px-4 md:px-8 lg:px-12 bg-primary-500">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">对 MossTalk 翻译耳机感兴趣？</h2>
          <p className="text-white/75 text-sm md:text-base mb-8">立即咨询产品详情、获取批量采购报价或下载产品白皮书</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href={earbudsData.cta.primary.href} className="px-8 py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer">
              <i className="ri-customer-service-2-line mr-2"></i>{earbudsData.cta.primary.text}
            </a>
            <Link to={earbudsData.cta.secondary.href} className="px-8 py-3.5 bg-primary-600 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-700 border border-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer">
              <i className="ri-file-download-line mr-2"></i>{earbudsData.cta.secondary.text}
            </Link>
            <Link to={earbudsData.cta.tertiary.href} className="px-8 py-3.5 bg-primary-600 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-700 border border-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer">
              <i className="ri-mail-send-line mr-2"></i>{earbudsData.cta.tertiary.text}
            </Link>
            <a href={earbudsData.cta.jd.href} target="_blank" rel="noopener noreferrer" className="px-8 py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer">
              <i className="ri-shopping-bag-line mr-2"></i>{earbudsData.cta.jd.text}
            </a>
          </div>
        </div>
      </section>

      {/* 咨询表单 */}
      <ConsultationForm badge="商务咨询" title="在线咨询 / 申领样品" subtitle="填写以下信息，我们的商务团队将在24小时内与您联系" />
    </>
  );
}

export default EarbudsPage;